import React from "react";
import DeleteModal from "../../../../../../components/Classroom/DeleteModal";
import ShareModal from "../../../../../../components/Classroom/ShareModal";
import RescheduleSessionDialog from "../../../../../AdminOrTeacherPages/EventsCalendar/components/rescheduleSessionDialog/rescheduleSessionDialog";

const LiveClassModals = ({
  // Delete modal props
  openDeleteModal,
  setOpenDeleteModal,
  onDeleteSubmit,

  // Share modal props
  openShareModal,
  setOpenShareModal,
  shareLink,

  // Suspend modal props
  openSuspendModal,
  setOpenSuspendModal,
  onSuspendSubmit,
  selectedLiveClass,
  setSelectedLiveClass,

  // Reschedule modal props
  openReschedule,
  setOpenReschedule,
  onRescheduleUpdate,
  classroomEndDate,
}) => {
  return (
    <>
      {/* Reschedule Dialog */}
      {openReschedule && (
        <RescheduleSessionDialog
          isOpen={openReschedule}
          onClose={() => {
            setOpenReschedule(false);
            setSelectedLiveClass({});
          }}
          selectedSession={selectedLiveClass}
          onUpdate={onRescheduleUpdate}
          classroomEndDate={classroomEndDate}
        />
      )}

      {/* Suspend/Resume Modal */}
      {openSuspendModal && (
        <DeleteModal
          open={openSuspendModal}
          showIcon={false}
          onClose={() => {
            setSelectedLiveClass({});
            setOpenSuspendModal(false);
          }}
          onSubmit={onSuspendSubmit}
          buttonText={`Yes, ${
            selectedLiveClass?.isSuspended ? "Resume" : "Suspend"
          }`}
          title={`${
            selectedLiveClass?.isSuspended ? "Resume" : "Suspend"
          } Live Class`}
          message={`Are you sure you want to ${
            selectedLiveClass?.isSuspended ? "resume" : "suspend"
          } this liveclass? This action cannot be undone.`}
        />
      )}

      {/* Delete Modal */}
      <DeleteModal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        onSubmit={onDeleteSubmit}
        buttonText={"Delete"}
        title={"Delete Live Class"}
        message={
          "Are you sure you want to delete this live class? This action cannot be undone."
        }
      />

      {/* Share Modal */}
      <ShareModal
        open={openShareModal}
        onClose={() => setOpenShareModal(false)}
        title={"Share this Live Class"}
        message={
          "Hi, We'd like to invite you to join our live class! Click the link below to join the live class:\n"
        }
        shareLink={shareLink}
      />
    </>
  );
};

export default LiveClassModals;
